import React, { useEffect, useMemo, useState } from 'react'
import productoRecomendadoArrow from '../../Assets/Images/Product/producto_recomendado_arrow.svg'
import { Row } from 'react-bootstrap'
import './recommended.css'
import ProductCard from 'Components/ProductCard'

const PRODUCTS_PER_PAGE = 4

const normalizeProduct = ({ name, productId, systemCode, ...product }) => ({
  ...product,
  ProductName: name ?? product.ProductName,
  ProductId: productId ?? product.ProductId,
  SystemCode: systemCode ?? product.SystemCode,
  TaxCategoryValue: product.TaxCategoryValue ?? 0.7,
})

const padProducts = products => {
  const missingProducts =
    (PRODUCTS_PER_PAGE - (products.length % PRODUCTS_PER_PAGE)) %
    PRODUCTS_PER_PAGE

  return [
    ...products,
    ...Array.from({ length: missingProducts }, (_, index) => ({
      key: `empty-${index}`,
      empty: true,
    })),
  ]
}

function ProductsCarrousel({
  data,
  title,
  productsRef,
  parentProduct,
  onProductDetailChange,
}) {
  const [firstIndex, setFirstIndex] = useState(0)
  const normalizedProducts = useMemo(
    () =>
      Array.isArray(data) ? data.filter(Boolean).map(normalizeProduct) : [],
    [data]
  )
  const finalData = useMemo(
    () => padProducts(normalizedProducts),
    [normalizedProducts]
  )
  const hasProducts = normalizedProducts.length > 0
  const lastIndex = firstIndex + PRODUCTS_PER_PAGE

  const handleNext = () => {
    if (lastIndex < finalData.length) {
      setFirstIndex(currentIndex => currentIndex + PRODUCTS_PER_PAGE)
    }
  }

  const handlePrev = () => {
    if (firstIndex > 0) {
      setFirstIndex(currentIndex =>
        Math.max(0, currentIndex - PRODUCTS_PER_PAGE)
      )
    }
  }

  useEffect(() => {
    setFirstIndex(0)
  }, [data])

  return (
    <>
      <div
        className="recommended-products"
        data-testid="container-products-carousel">
        <h2 data-testid="title-products-carrousel">{title}</h2>
        <div
          className={
            hasProducts ? 'products-carrousel' : 'products-carrousel-empty'
          }
          data-testid="container-products-carrousel-wrapper">
          {hasProducts && (
            <img
              src={productoRecomendadoArrow}
              onClick={handlePrev}
              style={{
                opacity: firstIndex === 0 ? '0' : '1',
                transform: 'rotate(180deg)',
              }}
              alt="left-arrow"
              data-testid="btn-carousel-prev"
            />
          )}
          <div
            className={
              hasProducts
                ? 'products-carrousel-content'
                : 'products-carrousel-empty'
            }
            data-testid="container-products-carrousel-content">
            <Row data-testid="list-products-carrousel">
              {hasProducts ? (
                finalData.slice(firstIndex, lastIndex).map((product, index) => {
                  return (
                    <ProductCard
                      key={
                        product.ProductId ||
                        product.SystemCode ||
                        product.key ||
                        index
                      }
                      data={product}
                      productsRef={productsRef}
                      parentProduct={parentProduct}
                      onProductDetailChange={onProductDetailChange}
                    />
                  )
                })
              ) : (
                <h3 data-testid="text-products-carrousel-empty">
                  No existen productos relacionados
                </h3>
              )}
            </Row>
          </div>
          {hasProducts && (
            <img
              src={productoRecomendadoArrow}
              onClick={handleNext}
              style={{ opacity: lastIndex >= finalData.length ? '0' : '1' }}
              alt="right-arrow"
              data-testid="btn-carousel-next"
            />
          )}
        </div>
      </div>
    </>
  )
}

export default ProductsCarrousel
